import React, { useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
// import ArrowdownText from '@/pages/intelligence/components/ArrowdownText';
import ChartTypeTab from '@/pages/intelligence/components/ChartsComponents/ChartTypeTab';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';


//每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Bar,
    dateType = 'Month',
    sortKeyName,
    seriesData,
    isNodata,
    fetchParams,
    xAxisData,
    tooltipFormatter,
    createLegendsCustomMade,
    yAxisFormatter,
    isVisualisLoading,
    currentLine,
    setSegment,
    topChartsType,
    imageType = 'mobile',
    titleNow,
    segment,
  } = props;

  const cardRef = useRef(null);

  // 获取折线图hooks
  const {
    lineOption
  } = useLineCharts({
    lineXAxisData: xAxisData, //x轴 label 数据
    lineSeriesData: seriesData, // 折线 数据
    legendsCustomMade: createLegendsCustomMade, // 图例
    yAxisFormatter, // y轴格式化函数
    // tooltipFormatter,// 悬浮窗轴格式化函数
    dateType,
    topChartsType,
    imageType,
    titleNow,
  });

  const handleMetricChange = (value: string): void => {
    setSegment(value);
    currentLine(value);
  };

  return (
    <>
      <div className="card-flex">
        <div className="card-title">
          <ChartTypeTab
            defaultValue={segment}
            selectType="retention"
            sendSegment={handleMetricChange}
          />
          {/* <ArrowdownText isNew={true} sortedData={sortKeyName} order={fetchParams.order} /> */}
        </div>
      </div>

      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          chartLoading={isVisualisLoading}
          lineOption={lineOption}
          chartType={chartType}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
